import { LitElement, html, classMap, createRef, ref } from './-global.min.js'

class WishlistPageShare extends LitElement {
  static properties = {
    socialMediaMode: {
      state: true,
    },
    state: {
      state: true,
    },
  }

  constructor() {
    super()

    this._swat = null
    this.socialMediaMode = []
  }

  connectedCallback() {
    super.connectedCallback()

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }

    window.SwymCallbacks.push(this.swymCallbackFn.bind(this))
  }

  swymCallbackFn(swat) {
    this.state = 'loaded'
    this._swat = swat

    this.socialMediaMode = swat.retailerSettings.Wishlist.SharingModes
  }

  render() {
    return html`<div class="main-wishlist__share-wrapper">
      <div class="main-wishlist__share-label utility">Share Wishlist</div>
      <div class="main-wishlist__share-items">
        ${this.socialMediaMode.map((item) => {
          return html`<wishlist-page-share-social-item
            platform="${item.type}"
          ></wishlist-page-share-social-item>`
        })}
        <wishlist-page-share-link></wishlist-page-share-link>
        <wishlist-page-share-email></wishlist-page-share-email>
      </div>

      <wishlist-page-share-email-modal></wishlist-page-share-email-modal>
    </div>`
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('wishlist-page-share', WishlistPageShare)

class WishlistPageShareSocialItem extends LitElement {
  static properties = {
    platform: {
      type: String,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  handleSocialShareButton() {
    const fromName = `${window.wishlistPageGlobal.customer.firstName} ${window.wishlistPageGlobal.customer.lastName}`

    const currentSocial = _swat.retailerSettings.Wishlist.SharingModes?.find(
      (social) => social.type === this.platform
    )

    _swat.shareListSocial(
      null,
      fromName,
      currentSocial?.url,
      this.platform,
      '',
      (data) => {
        console.error(data)
      }
    )
  }

  getSocialIcon(platform) {
    switch (platform) {
      case 'twitter':
        return html`<svg
          width="14"
          height="14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.62 3.06a5.6 5.6 0 0 1-1.6.44 2.78 2.78 0 0 0 1.22-1.54 5.5 5.5 0 0 1-1.77.67 2.78 2.78 0 0 0-4.83 1.91c0 .22.02.43.07.64A7.93 7.93 0 0 1 .95 2.26a2.79 2.79 0 0 0 .86 3.73 2.81 2.81 0 0 1-1.26-.35v.03A2.8 2.8 0 0 0 2.8 8.41a2.95 2.95 0 0 1-1.26.05 2.8 2.8 0 0 0 2.61 1.94A5.59 5.59 0 0 1 0 11.56c1.24.8 2.7 1.25 4.29 1.25 5.13 0 7.94-4.25 7.94-7.94l-.01-.36a6 6 0 0 0 1.4-1.45Z"
            fill="currentColor"
          />
        </svg>`
      case 'facebook':
        return html`<svg
          width="14"
          height="14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.14 14V7.61h2.25l.33-2.48H8.14v-1.6c0-.71.2-1.2 1.3-1.2h1.37V.1A19.4 19.4 0 0 0 8.8 0c-2 0-3.36 1.16-3.36 3.29v1.84H3.2V7.6h2.25V14h2.7Z"
            fill="currentColor"
          />
        </svg>`
    }
  }

  render() {
    return html`<button
      type="button"
      class="main-wishlist__share-item-btn"
      @click="${this.handleSocialShareButton}"
      aria-label="${this.platform}"
    >
      ${this.getSocialIcon(this.platform)}
    </button>`
  }

  createRenderRoot() {
    return this
  }
}

customElements.define(
  'wishlist-page-share-social-item',
  WishlistPageShareSocialItem
)

class WishlistPageShareLink extends LitElement {
  static properties = {
    isShow: {
      state: true,
    },
    onClickMessage: {
      state: true,
    },
  }

  constructor() {
    super()

    this.onClickMessage = 'Link Copied!'
  }

  connectedCallback() {
    super.connectedCallback()
  }

  handleShareLinkButton() {
    _swat.generateSharedListURL(
      null,
      this.handleOnSuccess.bind(this),
      (data) => {
        console.log(data)
        this.onClickMessage = 'Something went wrong, please try again.'
        this.isShow = true
      }
    )
  }

  async handleOnSuccess(data) {
    try {
      await navigator.clipboard.writeText(data)
      this.onClickMessage = 'Link Copied!'
      this.isShow = true

      setTimeout(() => {
        this.isShow = false
      }, 2500)
    } catch (error) {
      console.error('Failed to copy text: ', error)
    }
  }

  render() {
    return html`<div
      class="main-wishlist__share-item main-wishlist__share-item-share-link"
    >
      <button
        type="button"
        class="main-wishlist__share-item-btn"
        @click="${this.handleShareLinkButton}"
      >
        <svg
          width="14"
          height="14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.59 13.04A3.28 3.28 0 0 1 .96 8.41l2.57-2.57a3.28 3.28 0 0 1 4.63 0 .55.55 0 1 1-.77.77 2.17 2.17 0 0 0-3.09 0L1.73 9.2a2.17 2.17 0 0 0 0 3.08c.86.86 2.22.86 3.08 0l2.45-2.44a.55.55 0 1 1 .77.77l-2.44 2.44Zm4.88-4.88a3.28 3.28 0 0 1-4.63 0 .55.55 0 1 1 .77-.77c.87.86 2.23.86 3.09 0l2.57-2.58c.86-.86.86-2.22 0-3.08a2.17 2.17 0 0 0-3.08 0L6.74 4.17a.55.55 0 1 1-.77-.77L8.41.96a3.28 3.28 0 0 1 4.63 4.63l-2.57 2.57Z"
            fill="currentColor"
          />
        </svg>
      </button>

      <div
        class="main-wishlist__share-item-share-link-item caption ${classMap({
          'is-show': this.isShow,
        })}"
        role="alert"
        aria-live="polite"
      >
        ${this.onClickMessage}
      </div>
    </div>`
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('wishlist-page-share-link', WishlistPageShareLink)

class WishlistPageShareEmail extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  handleShareLinkButton() {
    const shareEmailModal = document.querySelector(
      'wishlist-page-share-email-modal'
    )

    shareEmailModal?.setAttribute('open', '')
  }

  render() {
    return html`<div class="main-wishlist__share-item">
      <button
        type="button"
        class="main-wishlist__share-item-btn"
        @click="${this.handleShareLinkButton}"
      >
        <svg
          width="14"
          height="14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M.82 2.33 7 7.31l6.18-4.98H.82ZM0 2.98v8.57h14V2.98L7.32 8.36a.51.51 0 0 1-.64 0L0 2.98Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>`
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('wishlist-page-share-email', WishlistPageShareEmail)

class WishlistPageShareEmailModal extends LitElement {
  static properties = {
    open: {
      reflect: true,
      type: Boolean,
    },
    _state: {
      state: true,
    },
  }

  $formEl = createRef()

  constructor() {
    super()

    this._state = 'idle'
  }

  connectedCallback() {
    super.connectedCallback()
  }

  updated(changedProperties) {
    if (changedProperties.has('open')) {
      this.openTimeout = setTimeout(() => {
        if (this.open) {
          document.body.classList.add('overflow-hidden')
        } else {
          document.body.classList.remove('overflow-hidden')
        }
      }, 10)
    }
  }

  closeWithEscape(e) {
    if (e.code.toUpperCase() === 'ESCAPE') {
      this.handleCloseModal()
    }
  }

  handleCloseModal() {
    this.removeAttribute('open')
    this._state = 'idle'
    this.$formEl?.value?.reset()
  }

  handleFormSubmit(e) {
    e.preventDefault()

    const formData = new FormData(e.target)
    const { name = '', email = '', note = '' } = Object.fromEntries(formData)

    _swat.sendListViaEmail(
      {
        toEmailId: email,
        fromName: name,
        note: note,
      },
      (r) => {
        this._state = 'success'
      },
      (r) => {
        this._state = 'error'
      }
    )
  }

  shareModalForm() {
    return html`<form
      ${ref(this.$formEl)}
      class="main-wishlist__email-modal-form"
      @submit="${this.handleFormSubmit}"
    >
      <hh-input-wrapper class="main-wishlist__email-modal-input-wrap mb1">
        <input
          slot="input"
          id="ShareEmailName"
          type="text"
          name="name"
          class="main-wishlist__email-modal-input"
        />
        <label
          slot="label"
          for="ShareEmailName"
          class="main-wishlist__email-modal-input-label"
        >
          Sender Name
        </label>
      </hh-input-wrapper>

      <hh-input-wrapper class="main-wishlist__email-modal-input-wrap mb1">
        <input
          slot="input"
          id="ShareEmailRecipient"
          type="email"
          class="main-wishlist__email-modal-input"
          name="email"
          required
        />
        <label
          slot="label"
          for="ShareEmailRecipient"
          class="main-wishlist__email-modal-input-label"
        >
          Recipient Email
        </label>
      </hh-input-wrapper>

      <hh-input-wrapper
        class="main-wishlist__email-modal-input-wrap main-wishlist__email-modal-input-wrap--message mb1"
      >
        <textarea
          slot="input"
          id="ShareEmailNote"
          name="note"
          cols="30"
          rows="10"
          class="main-wishlist__email-modal-textarea"
        ></textarea>
        <label
          slot="label"
          for="ShareEmailNote"
          class="main-wishlist__email-modal-input-label"
          >Message</label
        >
      </hh-input-wrapper>

      <hh-button-wrapper
        theme="primary"
        class="main-wishlist__email-modal-submit-wrapper"
      >
        <button type="submit" class="main-wishlist__email-modal-submit">
          Share List
        </button>
      </hh-button-wrapper>
    </form>`
  }

  successShareMessage() {
    return html`<h3 class="main-wishlist__email-modal-success- h3">
      Wishlist has been shared!
    </h3>`
  }

  render() {
    return html`<div
      class="main-wishlist__email-modal"
      aria-modal="true"
      role="dialog"
      @keyup="${this.closeWithEscape}"
    >
      <div
        class="main-wishlist__email-modal-overlay"
        aria-hidden="true"
        @click="${this.handleCloseModal}"
      ></div>
      <div class="main-wishlist__email-modal-container">
        <div class="main-wishlist__email-modal-panel">
          <div class="main-wishlist__email-modal-close-wrapper">
            <button
              type="button"
              aria-label="close"
              class="main-wishlist__email-modal-close"
              @click="${this.handleCloseModal}"
            >
              <svg
                width="12"
                height="11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 10.5 10.86.64 1 10.5ZM1.14.64 11 10.5 1.14.64Z"
                  stroke="currentColor"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
              </svg>
            </button>
          </div>
          <div class="main-wishlist__email-modal-content">
            <h2 class="main-wishlist__email-modal-title h5">
              Share List via Email
            </h2>
            ${this._state === 'success'
              ? this.successShareMessage()
              : this.shareModalForm()}
          </div>
        </div>
      </div>
    </div>`
  }

  createRenderRoot() {
    return this
  }
}

customElements.define(
  'wishlist-page-share-email-modal',
  WishlistPageShareEmailModal
)
